<template>
  <vue-editor
    v-model="content"
    class="product-rich-text-editor"
    :editor-toolbar="toolbar"
    :placeholder="placeholder"
  ></vue-editor>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ProductRichTextEditor',
  components: {
    VueEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    content: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  data() {
    return {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ['clean']
      ]
    }
  }
}
</script>

<style scoped>
.product-rich-text-editor::v-deep .ql-toolbar.ql-snow {
  padding: 4px 6px;
  border-color: #ced4da;
  border-radius: 0.25rem 0.25rem 0 0;
}

.product-rich-text-editor::v-deep .ql-container.ql-snow {
  min-height: 76px;
  font-family: inherit;
  font-size: inherit;
  border-color: #ced4da;
  border-radius: 0 0 0.25rem 0.25rem;
}

.product-rich-text-editor::v-deep .ql-editor {
  min-height: 76px;
  padding: 8px 10px;
}
</style>
